var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTaxiinline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_354_1114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5002 22.9999C17.8514 22.9999 23.0002 17.8512 23.0002 11.5C23.0002 5.14871 17.8514 0 11.5002 0C5.14895 0 0.000244141 5.14871 0.000244141 11.5C0.000244141 17.8512 5.14895 22.9999 11.5002 22.9999Z",
    fill: "#E09112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9659 12.391L16.4554 5.88049L9.21348 11.0548L6.03182 7.87327L4.78852 10.2029L4.69328 10.6536L7.48975 13.45H6.83497L6.54388 14.4976L5.34384 15.5473L6.05468 16.2581L5.68304 17.5955L11.0791 22.9916C11.2189 22.9966 11.3591 23.0001 11.5 23.0001C17.5514 22.9999 22.5112 18.3258 22.9659 12.391Z",
    fill: "#FF5419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08361 17.7634H6.00549C5.78789 17.7634 5.61148 17.587 5.61148 17.3694V15.2132C5.61148 14.9956 5.78789 14.8192 6.00549 14.8192H7.08352C7.30112 14.8192 7.47753 14.9956 7.47753 15.2132V17.3694C7.47762 17.587 7.30121 17.7634 7.08361 17.7634Z",
    fill: "#59595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9945 17.7634H15.9165C15.6989 17.7634 15.5225 17.587 15.5225 17.3694V15.2132C15.5225 14.9956 15.6989 14.8192 15.9165 14.8192H16.9945C17.2121 14.8192 17.3885 14.9956 17.3885 15.2132V17.3694C17.3885 17.587 17.2121 17.7634 16.9945 17.7634Z",
    fill: "#272525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3736 11.2281H16.6524V6.41767C16.6524 5.95777 16.2796 5.58496 15.8197 5.58496H7.18028C6.72038 5.58496 6.34757 5.95777 6.34757 6.41767V11.2281H5.62635C5.37183 11.2281 5.16541 11.4344 5.16541 11.689V15.1835C5.16541 15.438 5.37178 15.6444 5.62635 15.6444H17.3736C17.6282 15.6444 17.8346 15.438 17.8346 15.1835V11.6891C17.8346 11.4344 17.6282 11.2281 17.3736 11.2281Z",
    fill: "#273B7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3736 11.2281H16.6524V6.41767C16.6524 5.95777 16.2796 5.58496 15.8197 5.58496H11.4742V15.6445H17.3736C17.6282 15.6445 17.8346 15.4381 17.8346 15.1836V11.6891C17.8346 11.4344 17.6282 11.2281 17.3736 11.2281Z",
    fill: "#121149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.165 7.05719H6.83497V11.4736H16.165V7.05719Z",
    fill: "#71E2EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.165 7.05719H11.4744V11.4736H16.165V7.05719Z",
    fill: "#38C6D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9345 12.1868H8.0647V13.2574H14.9345V12.1868Z",
    fill: "#D0D1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9352 12.1868H11.4744V13.2574H14.9352V12.1868Z",
    fill: "#A6A8AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4736 12.1868H8.0647V13.2574H11.4736V12.1868Z",
    fill: "#D0D1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8978 12.1868H15.9164V13.2574H16.8978V12.1868Z",
    fill: "#A6A8AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08379 12.1868H6.10239V13.2574H7.08379V12.1868Z",
    fill: "#D0D1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8568 10.7151H5.83084C5.96839 10.7151 6.07988 10.6036 6.07988 10.466V8.01992C6.07988 7.88237 5.96839 7.77087 5.83084 7.77087H4.8568C4.71925 7.77087 4.60775 7.88237 4.60775 8.01992V10.466C4.60775 10.6036 4.71929 10.7151 4.8568 10.7151Z",
    fill: "#273B7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1691 10.7151H18.1432C18.2807 10.7151 18.3922 10.6036 18.3922 10.466V8.01992C18.3922 7.88237 18.2807 7.77087 18.1432 7.77087H17.1691C17.0316 7.77087 16.9201 7.88237 16.9201 8.01992V10.466C16.9201 10.6036 17.0316 10.7151 17.1691 10.7151Z",
    fill: "#121149"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_354_1114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxiinline);
export default __webpack_public_path__ + "static/media/taxi.inline.dab29e5e5baba689f3248d052c0de1a0.svg";
export { ForwardRef as ReactComponent };